import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import CareRecipients from './Pages/CareRecipients';
import Activities from './Pages/Activities';
import PriceItems from './Pages/PriceItems';
import CarePlan from './components/CarePlan';
import Quotations from './components/CareQuotation';
import CarePlanDetail from './components/CarePlanDetail';
import QuotationDetail from './components/QuotationDetails';
import HealthAssessment from './components/HealthAssessment';
import StaffDemandReport from './components/StaffDemandReport';
import StaffPrices from './components/StaffPrices';
import SettingsPage from './Pages/Settings';
import Layout from './Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './Pages/login';

function App() {
    return (
        <Router>
            <Routes>
                {/* Public Route */}
                <Route path="/" element={<Login />} />

                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>
                    <Route element={<Layout />}>
                        <Route path="/home" element={<Home />} />
                        <Route path="/care-recipients" element={<CareRecipients />} />
                        <Route path="/activities" element={<Activities />} />
                        <Route path="/priceList" element={<PriceItems />} />
                        <Route path="/careplans/:id" element={<CarePlan />} />
                        <Route path="/quotations/:id" element={<Quotations />} />
                        <Route path="/careplans/:id/:dateCreated" element={<CarePlanDetail />} />
                        <Route path="/quotation/:id/:dateCreated/:Qid" element={<QuotationDetail />} />
                        <Route path="/health-assessment" element={<HealthAssessment />} />
                        <Route path="/staff-demand-report" element={<StaffDemandReport />} />
                        <Route path="/staff-prices" element={<StaffPrices />} />
                        <Route path="/settings" element={<SettingsPage />} />
                    </Route>
                </Route>
            </Routes>
        </Router>
    );
}

export default App;